import { useMemo } from 'react';

import { usePageContentId, usePageSpaceKey } from '@confluence/page-context';

type MentionRequestModel = {
	contentId?: string;
	spaceId?: string;
	contextType?: string;
	mentionsSessionId?: string;
};

export const useMentionRequestModel = (): MentionRequestModel => {
	const [contentId] = usePageContentId(); // objectId
	const [spaceId] = usePageSpaceKey(); // containerId

	return useMemo(() => {
		return {
			contentId,
			spaceId,
			mentionsSessionId: crypto.randomUUID(),
			contextType: 'Mentions',
		};
	}, [contentId, spaceId]);
};
